import { render, staticRenderFns } from "@/modules/GeneralAgent/templates/general-agent-detail.html?vue&type=template&id=68dea518&scoped=true&"
import script from "@/modules/GeneralAgent/scripts/general-agent-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/GeneralAgent/scripts/general-agent-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/GeneralAgent/styles/general-agent-detail.scss?vue&type=style&index=0&id=68dea518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dea518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
